import { render, staticRenderFns } from "./LanguageDropDown.vue?vue&type=template&id=6ec4bc28"
import script from "./LanguageDropDown.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageDropDown.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LanguageDropDown.vue?vue&type=style&index=0&id=6ec4bc28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports